var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar",style:({ 'width': _vm.width + 'px'})},_vm._l((_vm.particles),function(count,index){return _c('div',{key:index,staticClass:"particles",class:{ 'over': index < _vm.currentCount }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }